module.exports = __webpack_public_path__ + "img/motorway_11x1.db283c32.svg";